import React from "react";
import { LayoutGrid, SlidersHorizontal } from "lucide-react";

export const PLAN_TABS = {
  READY_MADE: "ready-made",
  BUILD_YOUR_OWN: "build-your-own",
  CUSTOM_BENEFIT: "custom_benefit"
};

const TAB_ITEMS = [
  { key: PLAN_TABS.READY_MADE, label: "Ready-made plans", Icon: LayoutGrid },
  { key: PLAN_TABS.BUILD_YOUR_OWN, label: "Build your own plan", Icon: SlidersHorizontal },
  { key: PLAN_TABS.CUSTOM_BENEFIT, label: "Custom Benefit", Icon: LayoutGrid },
];


const PlanTabs = ({ active, onChange }) => (
  <div
    role="tablist"
    aria-label="Plan selection mode"
    className="no-scrollbar flex w-full items-center gap-1 overflow-x-auto rounded-2xl bg-[#EDEBF3] p-1 sm:inline-flex sm:w-auto"
  >
    {TAB_ITEMS.map((tab) => {
      const isActive = active === tab.key;
      return (
        <button
          key={tab.key}
          type="button"
          role="tab"
          id={`tab-${tab.key}`}
          aria-selected={isActive}
          aria-controls={`panel-${tab.key}`}
          onClick={() => onChange(tab.key)}
          className={`inline-flex shrink-0 items-center gap-2 px-3.5 sm:px-4 py-2.5 rounded-xl text-[13.5px] sm:text-sm font-semibold whitespace-nowrap transition-all duration-150 ${
            isActive
              ? "bg-white text-purple-700 shadow-[0_1px_3px_rgba(20,19,26,0.12)]"
              : "text-[#5B5866] hover:text-[#14131A]"
          }`}
        >
          <tab.Icon size={15} strokeWidth={2.25} />
          {tab.label}
        </button>
      );
    })}

    <style>{`
      .no-scrollbar::-webkit-scrollbar { display: none; }
      .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
    `}</style>
  </div>
);

export default PlanTabs;
